import React from "react";
import Dashboard from "../screens/dash/Dashboard.container";
import Repositories from "../screens/repositories/Repositories.container";
import Projects from "../screens/projects/Projects.container";
import TestCases from "../screens/testcases/TestCases.container";
import Profile from "../screens/profile/Profile.container";
import Login from "../screens/Login";
import Register from "../screens/Register";
import Validate from "../screens/Validate";
import ForgetPassword from "../screens/ForgetPassword";
import NotFound from "../screens/NotFound";
import ContainerMain from "../components/layout/ContainerMain";
import { USER_DATA } from "../utils/constants";

import { Routes, Route, useLocation, Navigate } from "react-router-dom";
import { auth } from "../api/firebase";
import { useAuthState } from "react-firebase-hooks/auth";
import Copyright from "../components/Copyright";

const MyRoutes = () => {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/validate" element={<Validate />} />
      <Route path="/forget-password" element={<ForgetPassword />} />
      <Route path="/" element={<Login />} />
      <Route element={<ContainerMain />}>
        <Route
          path="/projects"
          element={
            <RequireAuth>
              <Projects />
            </RequireAuth>
          }
        />
        <Route
          path="/dashboard"
          element={
            <RequireAuth>
              <Dashboard />
            </RequireAuth>
          }
        />
        <Route
          path="/repositories"
          element={
            <RequireAuth>
              <Repositories />
            </RequireAuth>
          }
        />
        <Route
          path="/projects/:id"
          element={
            <RequireAuth>
              <TestCases />
            </RequireAuth>
          }
        />
        <Route
          path="/profile"
          element={
            <RequireAuth>
              <Profile />
            </RequireAuth>
          }
        />
      </Route>

      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};
export default MyRoutes;

function RequireAuth(props: { children: any }) {
  const [user, loading, error] = useAuthState(auth);
  let location = useLocation();

  const isValidated = JSON.parse(
    localStorage.getItem(USER_DATA) || "{}"
  ).isValidated;

  if (loading) {
    return null;
  }
  if (!user || error || !isValidated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // var permissions = [];
  // const userData = localStorage.getItem(USER_DATA);

  // if (userData) {
  //   const userDataParsed = JSON.parse(userData);

  //   userDataParsed.permissions.forEach((element) => {
  //     permissions.push(element);
  //   });
  // }

  return props.children;
}
